import React, { useCallback } from 'react';
import Text from '../../styled/Text/index';
import Toggle from '../../styled/Toggle';
import styled from 'styled-components';
import { size } from '../../styled/layout/helpers';
import { H3 } from '../../styled/Heading';
import { ICookie } from '.';

const ToggleDiv = styled.div`
  display: flex;
  font-size: 1rem;
  justify-content: space-between;
  flex-direction: column;
  padding-top: ${size(1)};
`;

const OptionWrapper = styled.div`
  margin-top: 5;
  margin-right: 5;
  margin-bottom: ${size(1)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface IToggleOption {
  cookie: ICookie;
  setCookie: (name: string, active: boolean) => void;
}

const ToggleOption = ({ cookie, setCookie }: IToggleOption) => {
  const handleToggle = useCallback(() => {
    if (cookie.optional) {
      setCookie(cookie.name, !cookie.active);
    }
  }, [cookie]);

  return (
    <OptionWrapper>
      <Text weight="medium">{cookie.displayName}</Text>
      <Toggle
        disabled={!cookie.optional}
        isActive={cookie.active}
        onClick={handleToggle}
        title={cookie.displayName}
        data-testid={`cookie-toggle-${cookie.name}`}
      />
    </OptionWrapper>
  );
};

interface ICookieOptions {
  cookies: ICookie[];
  setCookies: React.Dispatch<React.SetStateAction<ICookie[]>>;
}

const CookieOptions = ({ cookies, setCookies }: ICookieOptions) => {
  const onSetCookie = useCallback(
    (name: string, active: boolean) => {
      const nextCookies = cookies.map((c) => ({ ...c }));
      const index = nextCookies.findIndex((c) => c.name === name);
      nextCookies[index].active = active;
      setCookies(nextCookies);
    },
    [cookies, setCookies],
  );

  return (
    <div style={{ marginTop: size(1) }}>
      <H3 style={{ borderBottom: '3px solid #eee' }}>Hantera dina inställningar</H3>
      <ToggleDiv>
        {cookies.map((cookie) => (
          <ToggleOption key={cookie.name} cookie={cookie} setCookie={onSetCookie} />
        ))}
      </ToggleDiv>
    </div>
  );
};

export default CookieOptions;
